import React from 'react';
import { Modal, Image } from 'react-bootstrap';
import CloseIcon from '../../../assets/images/prompt_close_icon.svg';
import desktopImage from 'assets/images/level/desktopLandscapeExample.png';
import mobileImage from 'assets/images/level/mobileLandscapeExample.png';
import './LevelReferenceModal.scss';

const LevelReferenceModal = ({
  show,
  setShow,
}) => {
  const onClose = () => {
    setShow(false);
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop='static'
    >
      <Modal.Body className={`base-prompt-container`}>
        <Image
          src={CloseIcon}
          className="base-prompt-close-button"
          onClick={onClose}
        />
        <div className="first-section-title">Reference for the background image cropping on front end</div>

        <div className='level-landscape-image-container'>
          <img alt="" src={desktopImage} className='level-desktop-landscape-image-example'/>
        </div>

        <div className='level-landscape-image-container'>
          <img alt="" src={mobileImage} className='level-mobile-landscape-image-example' />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default LevelReferenceModal;
